import React from "react";
import "./testimonials.css";
import AVTR1 from "../../assets/avatar1.jpg";
import AVTR2 from "../../assets/avatar2.jpg";
import AVTR3 from "../../assets/avatar3.jpg";
import AVTR4 from "../../assets/avatar4.jpg";

// import Swiper core and required modules
import {Pagination, Scrollbar} from 'swiper';

import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';


const data = [
  {
    avatar: AVTR1,
    name: "Roshani Singh",
    review:
      "Deleniti quod dignissimos veritatis fugit explicabo illo? Fugit voluptate impedit eaque, sint debitis ex deleniti vitae doloribus voluptatum facere earum neque quaerat illum nihil vero inventore aperiam optio voluptas.",
  },
  {
    avatar: AVTR2,
    name: "Keshav Vats",
    review:
      "Deleniti quod dignissimos veritatis fugit explicabo illo? Fugit voluptate impedit eaque, sint debitis ex deleniti vitae doloribus voluptatum facere earum neque quaerat illum nihil vero inventore aperiam optio voluptas.",
  },
  {
    avatar: AVTR3,
    name: "Prabhakar Singh",
    review:
      "Deleniti quod dignissimos veritatis fugit explicabo illo? Fugit voluptate impedit eaque, sint debitis ex deleniti vitae doloribus voluptatum facere earum neque quaerat illum nihil vero inventore aperiam optio voluptas.",
  },
  {
    avatar: AVTR4,
    name: "Dina Steven",
    review:
      "Deleniti quod dignissimos veritatis fugit explicabo illo? Fugit voluptate impedit eaque, sint debitis ex deleniti vitae doloribus voluptatum facere earum neque quaerat illum nihil vero inventore aperiam optio voluptas.",
  },
];

const Testimonials = () => {
  return (
    <section id="testimonials">
      <h5>Review from clients</h5>
      <h2>Testimonials</h2>

      <Swiper className="container testimonials__container"
      //install Swiper modules
      modules = {[Pagination]}
      spaceBetween = {40}
      slidesPerView = {1}
      pagination = {{clickable : true}}>
        {
            data.map(({avatar,name,review}, index) =>{
                return (
                  <SwiperSlide key = {index} className="testimonial">
                    <div className="client__avatar">
                      <img src={avatar} alt="Avatar One" />
                    </div>
                    <h5 className="client__name">{name}</h5>
                    <small className="client__review">
                      {review}
                    </small>
                  </SwiperSlide>
                );
            })
        }
      </Swiper>
    </section>
  );
};

export default Testimonials;
